<script lang="ts">

    import VariationsComparison from './VariationsComparison.svelte';
    import AiHint from './AiHint.svelte';
    import ProductImageOnexA from './ProductImageOnexA.svelte';
    import { trackClick } from './trackClick';
    import { escapeHtml } from './escapeHtml';

    interface Props {
      variationId: string
      variationsComparisonHeading: string
      variationsComparisonCaption: string
      imageUrl: string
      imageAltText: string
      variationUrl: string
    }

    let {
      variationId,
      variationsComparisonHeading,
      variationsComparisonCaption,
      imageUrl,
      imageAltText,
      variationUrl,
    }: Props = $props();
</script>

<a
    class="ft5-upselling-link"
    data-transaction-name="FT5 Upselling Component"
    href={variationUrl}
    onclick={() => trackClick(variationId)}
>
    <div class="ft5-upselling-container">
        <VariationsComparison
            style="margin-top: 4px; margin-bottom: 4px;margin-left: 4px"
            heading={escapeHtml(variationsComparisonHeading)}
            caption={escapeHtml(variationsComparisonCaption)}
        />
        <ProductImageOnexA
            altText={imageAltText}
            url={imageUrl}
        />
    </div>
</a>
<AiHint/>

<style lang="scss">
  .ft5-upselling-link {
    text-decoration: none;
  }

  .ft5-upselling-container {
    padding: 8px;
    background-color: #f0f0f0;
    border-radius: 16px;
    display: flex;
    gap: 16px;
  }
</style>
